import css from './app.scss'
import cls from 'classnames'
import Cookie from 'js-cookie'
import React, { FC, useState, useLayoutEffect, useRef, ReactElement, useEffect } from 'react'

/*
  @douban
*/
import NavTitleWeb from '@douban/rexxar-common/es/components/NavTitleWeb'
import { callUri } from '@douban/rexxar-common/es/assets/js/uri'
import { openShareWidget } from '@douban/rexxar-common/es/assets/js/utils'
import { IcBack, IcShare } from '@douban/rexxar-common/es/components/NavTitleWeb/icons'
import Location from '@douban/rexxar-common/es/assets/js/Location'
import { listenMessageFromClient } from '@douban/client-listener/es/webview/listener';
import { CallToast } from '@src/common/utils/rexxar-toast'
// import { frdVersion } from '@douban/rexxar-common/es/assets/js/version';
/*
  common
*/
import { API_HOME, closeWebViewUrl, DISPATCH_URL } from '@src/common/const'
import { getData } from '@src/common/service'
import { HomeDataScheme } from '@src/common/types'
import Log from '@src/common/utils/log'
import { collectCake, collectInvitationLetter } from '@src/common/service'
import { useFlexible } from '@src/common/utils/flexible'
import { formatDate } from '@src/common/utils'
import { getFrodoVersion, extractVersionFrom, FRODO_UA_PATTERN, frdVersion } from '@src/common/utils/frodo-version';


export type BeansTransactionDoneResult = {
  shop_id: string,
  gadget_id: string,
  feature_name: string
}

const location = new Location()
const isFromEgg = location.query.from === 'egg'
const customErrorMsg = location.query.error_msg
const customUnlogin = location.query.unlogin === 'true'
const stage = location.query.stage || '1'

const App: FC = () => {
  const [collected, setCollected] = useState<boolean>(false)
  const [data, setData] = useState<HomeDataScheme | null>(null)
  const [errorMsg, setErrorMsg] = useState<string | null>(null)
  const [hasLogin, setHasLogin] = useState<boolean | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const detectorRef = useRef<HTMLSpanElement>(null)
  const isFontSizeModified = useCheckFontSize(12, 5, detectorRef)

  useFlexible()

  // 添加单独的 useEffect 来监控字体大小变化
  useEffect(() => {
    if (isFontSizeModified) {
      console.log('isFontSizeModified', isFontSizeModified)
      CallToast('info', '系统字体大小异常，请调整系统字体大小')
    }
  }, [isFontSizeModified])

  useLayoutEffect(() => {
    if (!customUnlogin) {
      setIsLoading(true)
      getData(API_HOME).then((data) => {
        setData(data)

        if (data) {
          setCollected(data.has_collected)
          setHasLogin(true)
          setIsLoading(false)
        }
      }).catch((error) => {
        // 未登录
        if (error.data.code === 1002) {
          setHasLogin(false)
        }

        setErrorMsg(error.data.localized_message)
        setIsLoading(false)
      })
    }
  }, [])

  useEffect(() => {
    if (isFromEgg) {
      Log('egg_enter', {
        'type': 'douban20th',
        'uri': location.href,
      })
    } else {
      Log('enter_c9_page', {
        'uri': location.href,
      })
    }
  }, [])

  useEffect(() => {
    // 在客户端中送出生日蛋糕券后的回调
    listenMessageFromClient<BeansTransactionDoneResult>('onBeansTransactionDone', (res) => {

      // 重新请求一次总接口
      // 用来更新 has_invited_all 状态
      getData(API_HOME).then((data) => {
        setData(data)

        if (data) {
          setCollected(data.has_collected)
        }
      })
    })
  }, [data])

  const renderLogin = () => {
    return (
      <div className={ css.login }>
        <div className={ css.login_card }>
          <a
            // size={Size.xl}
            href={`https://accounts.douban.com/login?redir=${encodeURIComponent(
              window.location.href,
            )}`}
          >
            请登录
          </a>
        </div>
      </div>
    );
  }

  const collectCakeBtn = () => {
    return (
      <button className={ cls(css.cake_btn, {
        [css.has_collected]: collected
      }) }
        disabled={ collected }
        onClick={() => {
          if (collected) {
            return
          }

          Log('accept_douban20th_cake', {
            'since_0307': data?.is_invitation_ended,
          })

          collectCake().then((res) => {
            if (res.has_collected) {
              setCollected(true)
            }
          })
          .catch((error) => {
            alert(`收下蛋糕失败: ${error.data.localized_message}`)
          })
        }}
      >
        { collected ? '已收下' : '收下蛋糕' }
      </button>
    )
  }

  const renderHomePage = (data: HomeDataScheme) => {
    return (
      <div className={css.app}>
        <div className={css.welcome}>
          <div className={css.userName}>
            {`${data.user?.name || ''}:`}
          </div>
          <p className={css.welcome_text}>
            很开心这个春天又与你一起度过，<br />
            这也是我们共同度过的第{ data.spring_count }个春天。<br />
            { formatDate(data.reg_date) }你来到豆瓣，<br />
            在这里，你分享了很多美好瞬间，<br />
            也留下了独属于这里的记忆。<br />
            今天是豆瓣20岁生日，感谢你的到来。<br />
            一起来吃蛋糕吧！
          </p>
        </div>

        { collectCakeBtn() }

        { collected ? (
          <div className={css.invite_btn_wrapper}>
            <button className={ cls(css.invite_btn, {
              [css.has_invited_all]: data.has_invited_all
            }) }
              disabled={ data.has_invited_all }
              onClick={() => {
                if (data.has_invited_all) {
                  return
                }

                Log('invite_douban20th_cake')

                // 领取邀请券
                collectInvitationLetter().then((res) => {
                  // 成功后调起客户端窗口
                  if (frdVersion.since('7.94')) {
                    callUri(`douban://douban.com/beans/gadget/${data.invitation_letter.id}?with_msg=true&show_target=true&isTransparent=true`)
                  } else {
                    // 生日蛋糕券已发放至背包
                    CallToast('info', '生日蛋糕券已发放至背包')
                  }
                })
                // .catch((error) => {
                //   alert(`领取邀请券失败:${error.data.localized_message}`)
                // })
                
              }}
            >
              { data.has_invited_all ? '已全部邀请': '邀请友邻来吃蛋糕' }
            </button>
          </div>
        ) : null }
      </div>
    )
  }

  const renderMain = () => {
    if (data) {
      // 如果整体活动已结束，直接返回4
      if (data.is_ended || (data.is_invitation_ended && data.has_collected)) {
        return (
          <div className={css.app3}>
            <div className={css.main}>
              <button className={css.back_btn}
                onClick={() => {
                  callUri(closeWebViewUrl)
                }}
              >返回</button>
            </div>
          </div>
        )
      }

      // 判断邀请活动是否结束
      if (data.is_invitation_ended) {
        return (
          <div className={css.app2}>
            <div className={css.main}>
              { collectCakeBtn() }
            </div>
          </div>
        )
      }

      return renderHomePage(data)
    }
  }

  return (
    <>
      <span className='am-font-size-detector'
        ref={detectorRef}
      >
        豆
      </span>

      {/* <div className={ cls(css.navWrapper, 'am-nav-wrapper') }>
        <div className={ cls(css.nav, 'am-nav')}>
          <div
            className={cls(css.backBtn, 'am-back-btn')}
            onClick={() => {
              callUri(closeWebViewUrl)
            }}
          >
            <IcBack color={'#000'} />
          </div>

          <div className={ cls(css.shareBtn, 'am-share-btn')} onClick={ () => {
            openShareWidget()
          } }>
            <IcShare color='#000' />
          </div>
        </div>
      </div> */}

      { isLoading ? <div className={css.loading}>加载中...</div> : (
        <>
          { (!hasLogin || customUnlogin) && !errorMsg ? renderLogin() : errorMsg || customErrorMsg ? <div className={css.errorWrapper}>{ errorMsg }</div> : renderMain() }
        </>
      ) }
    </>
  )
}

const useCheckFontSize = (
  expectedFontSize: number, 
  tolerance = 1,
  detectorRef: React.RefObject<HTMLSpanElement>
): boolean => {
  const [isFontSizeModified, setIsFontSizeModified] = useState(false);

  useEffect(() => {
    const detector = detectorRef.current;
    if (!detector) return;
    
    // 获取预期尺寸
    const expectedWidth = expectedFontSize;
    const expectedHeight = expectedFontSize;


    // 获取实际尺寸
    const actualWidth = detector.offsetWidth;
    const actualHeight = detector.offsetHeight;

    console.log('actualWidth', actualWidth)
    console.log('actualHeight', actualHeight)

    // 判断是否与预期尺寸一致（允许误差）
    const isWidthChanged = Math.abs(actualWidth - expectedWidth) > tolerance;
    const isHeightChanged = Math.abs(actualHeight - expectedHeight) > tolerance;

    if (isWidthChanged || isHeightChanged) {
        setIsFontSizeModified(true);
    } else {
        setIsFontSizeModified(false);
    }
  }, [expectedFontSize, tolerance, detectorRef]);

  return isFontSizeModified;
};


export default App
